import _Abstract from "system/abstract";

export default class Component_CulturePopUp extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {}, options), 'module');
    this.initModule();
  }

  initModule() {
    this.initListeners();
  }

  initListeners() {
    let _this = this;
    if(_this.getCookie("culture") === ""){
      setTimeout(function(){
        $(_this.el).removeClass("c-modal__hidden");
      }, _this.options.popupDelayTime)
    }

    //--Cancel Button Clicked
    function onCancelPopup() {
      $(_this.el).fadeOut("fast");
      _this.setCookie("culture", "true", 100000);
    }
    
    $(".c-modal--culture .-icon_close, .c-modal--culture .c-btn:not('.-active'),.c-modal--culture .c-modal__desc a").on("click", onCancelPopup)
  }
}



/** WEBPACK FOOTER **
 ** ./components/culture-pop-up.js
 **/